import PropTypes from 'prop-types';

/**
 * Button with normal and Suggestion variants
 * @param {{
 * variant:"normal" | "suggestion_off" | "suggestion_on",
 * children:string | JSX.Element,
 * disabled?:boolean | undefined,
 * onClick?:React.MouseEventHandler<HTMLButtonElement>
 * cursorNotAllowed?:boolean
 * }} param0
 * @returns
 */
export default function Button({
  children,
  variant,
  cursorNotAllowed,
  ...props
}) {
  const color = {
    normal: 'bg-segments-gray-F1 text-black hover:bg-segments-darker-gray',
    suggestion_off:
      'bg-segments-accent-color-orange text-white hover:bg-segments-accent-color-dark-orange border-segments-accent-color-orange',
    suggestion_on: 'border-segments-accent-color-orange',
  };

  return (
    <button
      aria-label={String(children)}
      className={`border block w-full text-base font-bold focus:outline-none rounded-3xl ${
        color[variant]
      } disabled:opacity-50 ${cursorNotAllowed && 'cursor-not-allowed'}`}
      {...props}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  variant: PropTypes.oneOf(['normal', 'suggestion_off', 'suggestion_on'])
    .isRequired,
  disabled: PropTypes.bool,
};
